import { AdminApproval } from '../approval';
import { IUser } from '../common';
import { Request, RequestStatus, CsaRequestStatus } from '.';
import { Request as LegacyReq } from '../legacy';
import { LegacyStatus } from '../legacyStatus';
import { Request as HelpDeskRequest } from '../help-desk';

export const panels = ({
  user,
  disableOperationsHelpDsk,
}: {
  user: IUser;
  disableOperationsHelpDsk: boolean;
}) => [
    {
      value: 0,
      panel: () => <AdminApproval title="RA Approvals" />,
    },
    {
      value: 1,
      panel: () => <Request raTab={true} user={user} key="Revocations" />,
    },
    {
      value: 2,
      panel: () => (
        <RequestStatus
          di={false}
          requestorEmail=""
          disableOperationsHelpDsk={disableOperationsHelpDsk}
        />
      ),
    },
    {
      value: 3,
      panel: () => <CsaRequestStatus />,
    },
    {
      value: 4,
      panel: () => <LegacyReq user={user} />,
    },
    {
      value: 5,
      panel: () => <LegacyStatus />,
    },
    {
      value: 6,
      panel: () =>
        <HelpDeskRequest
          user={user}
          key="Search Users"
          searchUsers
          forRegistrantsNCoordinators={false}
          // raTab={true}
        />
    },
  ];
